export default "__VITE_ASSET__e495cb05__"